module.exports = __webpack_public_path__ + "img/Minguante.da138dae.svg";